import { render } from "./RevenueChart.vue?vue&type=template&id=17130fdc&scoped=true"
import script from "./RevenueChart.vue?vue&type=script&lang=js"
export * from "./RevenueChart.vue?vue&type=script&lang=js"

import "./RevenueChart.vue?vue&type=style&index=0&id=17130fdc&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17130fdc"]])

export default __exports__